// extracted by mini-css-extract-plugin
export default {"image":"success_image__zdD+l","deviceAdd":"success_deviceAdd__LR3Hr","text":"success_text__izkdI"};